export default "__VITE_ASSET__ClrInSAz__"